export const profitOf = (lines) => {
  const ls = lines.filter((l) => l.sell > 0);
  const pieces = ls.reduce((s, l) => s + l.q, 0);
  const pay = ls.reduce((s, l) => s + l.unit * l.q, 0);
  const sell = ls.reduce((s, l) => s + l.sell * l.q, 0);
  return { pieces, pay, sell, win: sell - pay, even: sell > 0 ? Math.min(pieces, Math.ceil((pay / sell) * pieces)) : 0 };
};

export default function BFProfit({ lines }) {
  const r = profitOf(lines);
  if (!r.pieces || r.win <= 0) return null;
  return (
    <section className="bf-profit" data-testid="bf-profit">
      <b className="bf-profit-title">Black Friday-ul tău: cât câștigi dacă revinzi produsele alese de tine</b>
      <div className="bf-profit-grid">
        <div className="is-win"><small>Câștigi din tot ce vinzi</small><strong data-testid="bf-profit-win">{Math.round((r.win / r.sell) * 100)}%</strong></div>
      </div>
      <p data-testid="bf-profit-even">Vinzi <b>{r.even}</b> din <b>{r.pieces}</b> produse și ți-ai scos banii. Restul e câștigul tău.</p>
      <small className="bf-profit-note">Calcul la prețul recomandat pentru clientele tale, mai mic decât prețul din magazinul online.</small>
    </section>
  );
}
